module.exports = __webpack_public_path__ + "assets/img/platformleft.a581a22e.png";